import { render, staticRenderFns } from "./AddBrokerComponent.vue?vue&type=template&id=673de1f6&"
import script from "./AddBrokerComponent.vue?vue&type=script&lang=js&"
export * from "./AddBrokerComponent.vue?vue&type=script&lang=js&"
import style0 from "./AddBrokerComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports